import * as React from 'react';
import { Icon, iconsMap, Layout, namespacedClassnames, Text } from '../..';
import { compKey } from './key';
export var SelectorButton = function (props) {
    var cn = namespacedClassnames(compKey, props.className);
    return (React.createElement("div", { className: cn, onClick: props.onClick },
        React.createElement(Layout, { orientation: 'horizontal', gap: '6', padding: '8', verticalAlignment: 'center' },
            React.createElement(Text, { type: 'hxs', color: 't40', className: 'title' }, props.title),
            React.createElement(Text, { color: 't20', className: 'selected-item' }, props.selectedItem),
            React.createElement(Icon, { icon: iconsMap.dropDownToggle }))));
};
//# sourceMappingURL=index.js.map